import { MDBCol, MDBContainer } from "mdb-react-ui-kit";
import { FC } from "react";
import { useIsMD } from "@/utils/hooks/useWindowSizes";
import Image from "next/legacy/image";
import { StaticImageData } from "next/image";
import { Section } from "@/models/home";
import styles from "../../styles/common/HeadSection.module.scss";
import SectionTitle from "./SectionTitle";
import { HeadSectionContent, ISectionTitle } from "../../models/common/common";
import localImage from "../../public/images/contact.png";
import localImageMobile from "../../public/images/contacts_image.jpeg";

const HeadSection: FC<{
    className?: string;
    backgroundIsEmpty?: boolean;
    content: HeadSectionContent;
    wordingsDelta?: Section;
}> = ({ className, content, backgroundIsEmpty, wordingsDelta }) => {
    const title: ISectionTitle = {
        title: content.title,
        subTitle: content.subTitle,
        classNameTitle: styles.sectionTitle,
        classNameSubTitle: styles.textSubTitle,
        alignment: "justify-content-start text-start",
        titleColumnSize: 12,
        classNameContainer: "py-3",
    };

    const titleMobile: ISectionTitle = {
        ...title,
        classNameTitle: "text-sm",
    };

    const md = useIsMD();

    const renderImage = (
        src: StaticImageData,
        sizes: string,
        classNameType: string,
        titleProps: ISectionTitle,
        containerStyle: object
    ) => (
        <div
            style={{ position: "relative", zIndex: 50 }}
            className={classNameType}
        >
            <Image
                src={src}
                alt="IMG_CONTACT"
                sizes={sizes}
                className="w-full h-auto"
            />
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    zIndex: 1000,
                    ...containerStyle,
                }}
                className={styles.headPaddingContainer}
            >
                <MDBCol size={6}>
                    <SectionTitle
                        sectionTitle={titleProps}
                        wordingsDelta={wordingsDelta}
                    />
                </MDBCol>
            </div>
        </div>
    );

    return (
        <MDBContainer fluid className={`${className} ${styles.headBgColor}`}>
            {backgroundIsEmpty ? (
                <div
                    style={{ height: "auto" }}
                    className={styles.headBgImageContainer}
                >
                    {renderImage(
                        localImage,
                        "(min-width: 1024px) 750px",
                        styles.desktopImage,
                        title,
                        { bottom: "-5rem" }
                    )}
                    {renderImage(
                        localImageMobile,
                        "(min-width: 768px) and (max-width: 1023px) 600px",
                        styles.tabletImage,
                        title,
                        { bottom: 0 }
                    )}
                    {renderImage(
                        localImageMobile,
                        "(max-width: 767px) 280px",
                        styles.mobileImage,
                        titleMobile,
                        { bottom: 0, padding: 10 }
                    )}
                </div>
            ) : (
                <div
                    className={styles.headBgImageContainer}
                    style={{
                        background: backgroundIsEmpty
                            ? "#F5F5F5"
                            : `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%), url(${content.backgroundImageUrl}), #F5F5F5`,
                    }}
                >
                    <div className={styles.headPaddingContainer}>
                        <MDBCol size={md ? 12 : 6}>
                            <SectionTitle
                                sectionTitle={title}
                                wordingsDelta={wordingsDelta}
                            />
                        </MDBCol>
                    </div>
                </div>
            )}
        </MDBContainer>
    );
};

HeadSection.defaultProps = {
    className: "",
};

export default HeadSection;
